import React, { useState } from "react";
import { Types } from "./Types";
import styles from "./Components.module.css";
import { useTranslation } from "react-i18next";
const LongText = () => {
  const { t } = useTranslation();
  const [isDragging, setIsDragging] = useState(false);

  return (
    <div
      className={`form-group draggable ${styles["form-group"]} ${isDragging ? styles["dragging"] : ""}`}
      draggable={true}
      onDragStart={(e) => {
        e.dataTransfer.setData("add", Types.LONGTEXT);
        setIsDragging(true);
      }}
      onDragEnd={(e) => {
        setIsDragging(false);
      }}
    >
      <span className="fab fa-rocketchat fa-3x d-block pl-2"></span>
      <label className="form-control-label">{t("Longtext")}</label>
    </div>
  );
};

export default LongText;
